/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_PinInputs */

const cs_chat_pin = /** @type {(inputs: Chat_PinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připnout konverzaci`)
};

const en_chat_pin = /** @type {(inputs: Chat_PinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pin conversation`)
};

/**
* | output |
* | --- |
* | "Pin conversation" |
*
* @param {Chat_PinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_pin = /** @type {((inputs?: Chat_PinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_PinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_pin(inputs)
	return cs_chat_pin(inputs)
});